import { PartnerDuplicatesContentActions } from 'legacy/lut/components/widgets/public/partnerDuplicates/components/partnerDuplicatesContent/partnerDuplicatesRow/expandedRowContent/partnerDuplicatesContentActions/PartnerDuplicatesContentActions'
import { PartnerDuplicatesContentMessages } from 'legacy/lut/components/widgets/public/partnerDuplicates/components/partnerDuplicatesContent/partnerDuplicatesRow/expandedRowContent/partnerDuplicatesContentMessages/PartnerDuplicatesContentMessages'
import {
  IContentActions,
  IContentMessages,
} from 'legacy/lut/components/widgets/public/partnerDuplicates/models'
import React, { useMemo } from 'react'

import { IPartner, IPartnerDuplicate, TPartnerDifference } from 'clickNgo/entities/partner/models'

import { ApolloMatchesDiff } from './components/apolloMatchesDiff/ApolloMatchesDiff'

import styles from './ApolloMatchesRowContent.module.scss'

interface IApolloMatchesRowContent extends IContentActions, IContentMessages {
  searchResult: IPartnerDuplicate
  onPartialReplace?: (field: keyof IPartner, newValue: string, partner: IPartner) => void
  sortDifference?: (a: TPartnerDifference, b: TPartnerDifference) => number
}

export const ApolloMatchesRowContent = ({
  searchResult,
  onPartialReplace,
  sortDifference,
  contentMessages,
  contentActions,
}: IApolloMatchesRowContent) => {
  const { difference, partner } = searchResult

  const sortedDifference = useMemo(
    () => [...difference].sort(sortDifference),
    [difference, sortDifference]
  )

  return (
    <div>
      <ApolloMatchesDiff
        difference={sortedDifference}
        partner={partner}
        onPartialReplace={onPartialReplace}
      />
      <div className={styles.actions}>
        <PartnerDuplicatesContentMessages
          partner={partner}
          searchResult={searchResult}
          contentMessages={contentMessages}
        />

        <PartnerDuplicatesContentActions
          partner={partner}
          searchResult={searchResult}
          contentActions={contentActions}
        />
      </div>
    </div>
  )
}
